module.exports = __webpack_public_path__ + "img/social_2.1a6e3c43.svg";